import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import InlineDealerParagraph from "./InlineDealerParagraph";
import './InlineDealerPage.scss';

interface Data {
    nodeById: {
        entityLabel: string;
        entityId: number;
        fieldComponents: Array<{targetId: number}>;
    }
}

class InlineDealerPageQuery extends Query<Data, {id: string}> {}

const GET_PAGE = gql`
    query nodeById($id: String!) {
        nodeById(id: $id) {
            entityLabel
            entityId
            ... on NodeLandingPage {
                entityLabel
                fieldComponents {
                    targetId
                }
            }
            ... on NodeLegalPage {
                entityLabel
                fieldComponents {
                    targetId
                }
            }
            ... on NodeDealerRankingsPage {
                entityLabel
                fieldComponents {
                    targetId
                }
            }
        }
    }
`;

const InlineDealerPage = ({pageID, group, headline, gridType}) => (
    <InlineDealerPageQuery asyncMode query={GET_PAGE} variables={{ id: pageID }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error || !data.nodeById) return <div>{error || null}</div>;

            const page = data.nodeById;


            return (
                <div className={`inlineDealerPage inlineDealerPage--${gridType}`}>
                    {page.fieldComponents && page.fieldComponents.map(component => (
                        <InlineDealerParagraph key={`${page.entityId}_${component.targetId}`}
                                               id={String(component.targetId)}
                                               group={group}
                                               headline={headline}
                                               gridType={gridType}/>
                    ))}
                </div>
            );
        }}
    </InlineDealerPageQuery>
);

InlineDealerPage.propTypes = {
    pageID: PropTypes.number.isRequired,
    group: PropTypes.string,
    headline: PropTypes.string,
    gridType: PropTypes.string
};

InlineDealerPage.defaultProps = {
    group: '',
    headline: '',
    gridType: 'horizontal'
};

export default InlineDealerPage;



// WEBPACK FOOTER //
// ./frontend/components/InlineDealer/InlineDealerPage.jsx